export default __webpack_public_path__ + "static/media/emerald_orb.4008f986.png";